module.exports = __webpack_public_path__ + "assets/media/arrow-down.15b4caa4.svg";